import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Tariffs extends CommonCRUD {
    async calculateEstimate(orderId, info) {
        const { id, ...rest } = info;
        return await this.api.fetch({
            method: "post",
            url: `/${this.schema}/calculate_order_by_estimate`,
            data: { order_id: orderId, ...rest },
        });
    }

}

export default Tariffs;
